import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../global/styles/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    padding: `${theme.spacing(4)}px 0px`,
    width: '80%',
    maxWidth: 600,
    margin: '0 auto',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: 'inherit',
      margin: 0,
    },
  },
  tagButton: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
  },
  topBottomSpacing: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  tagRemove: {
    color: theme.colors.danger,
    borderColor: theme.colors.danger,
  },
  doubleIcon: {
    position: 'relative',
    height: 24,
  },
  plusIcon: {
    position: 'absolute',
    top: 12,
    right: -2,
    fontSize: 14,
  },
  formContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  gridItem: {
    width: 120,
    height: 120,
    position: 'relative',
    backgroundColor: 'rgba(0,0,0,0.2)',
    margin: `0px ${theme.spacing(1)}px ${theme.spacing(1)}px 0px`,
  },
  gridText: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.2)',
    color: theme.colors.white,
    padding: 3,
  },
}));

export default useStyles;
